import React from "react";
import { Modal } from "antd";
import SettlementTransactionsTable from "../../Tables/SettlementTransactionsTable";
import "./style.css";

const formatAmount = (value) =>
  `$${(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const SettlementTransactionsModal = ({ open, onClose, settlement }) => {
  const transactions = settlement?.transactions || [];
  const total = transactions.reduce(
    (sum, txn) => sum + (parseFloat(txn.amount) || 0),
    0,
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={null}
      width={900}
      centered
      destroyOnHidden
      className="settlement-txn-modal"
    >
      <div className="settlement-txn-modal__header">
        <div className="settlement-txn-modal__title">Settlement Transactions</div>
        <div className="settlement-txn-modal__subtitle">
          {settlement?.title && (
            <span className="settlement-txn-modal__id">{settlement.title}</span>
          )}
          {transactions.length} transaction
          {transactions.length === 1 ? "" : "s"} covered by this payment
        </div>
      </div>

      <div className="settlement-txn-modal__body">
        <div className="settlement-txn-modal__table">
          <SettlementTransactionsTable transactions={transactions} />
        </div>
      </div>

      <div className="settlement-txn-modal__footer">
        <span>Total</span>
        <span className="settlement-txn-modal__total">
          {formatAmount(total)}
        </span>
      </div>
    </Modal>
  );
};

export default SettlementTransactionsModal;
